module.exports = __webpack_public_path__ + "img/pro-list2.27bd58b6.png";